import zoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  Filler,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// クロスヘア描画プラグイン
const crosshairPlugin = {
  id: "crosshair",
  // @ts-ignore
  afterDraw: (chart: any, _args: any, options: any) => {
    const activeXMs = chart?.$activeXMs ?? options?.activeXMs;
    if (typeof activeXMs !== "number" || !Number.isFinite(activeXMs)) return;
    try {
      const xScale = chart?.scales?.x;
      if (!xScale) return;
      const getPixel =
        typeof xScale.getPixelForValue === "function"
          ? xScale.getPixelForValue.bind(xScale)
          : null;
      if (!getPixel) return;
      const x = getPixel(activeXMs);
      if (x == null) return;
      const ctx = chart.ctx;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, chart.chartArea.top);
      ctx.lineTo(x, chart.chartArea.bottom);
      ctx.lineWidth = options?.lineWidth ?? 1;
      ctx.strokeStyle = options?.color ?? "#ff9800";
      ctx.stroke();
      ctx.restore();
    } catch (e) {
      // 無視
    }
  },
};

// 選択点ハイライト描画プラグイン
const highlightPointPlugin = {
  id: "highlightPoint",
  // @ts-ignore
  afterDraw: (chart: any) => {
    const hl = chart?.$highlightPoint;
    if (!hl) return;
    const xMs = hl?.xMs;
    const y = hl?.y;
    if (typeof xMs !== "number" || !Number.isFinite(xMs)) return;
    if (typeof y !== "number" || !Number.isFinite(y)) return;

    try {
      const xScale = chart?.scales?.x;
      const yScale = chart?.scales?.y;
      if (!xScale || !yScale) return;
      if (typeof xScale.getPixelForValue !== "function") return;
      if (typeof yScale.getPixelForValue !== "function") return;

      const x = xScale.getPixelForValue(xMs);
      const py = yScale.getPixelForValue(y);
      if (x == null || py == null) return;

      const ctx = chart.ctx;
      const radius = typeof hl?.radius === "number" ? hl.radius : 3;
      const fill = typeof hl?.fill === "string" ? hl.fill : "#ff9800";
      const stroke = typeof hl?.stroke === "string" ? hl.stroke : "#ff9800";
      const lineWidth = typeof hl?.lineWidth === "number" ? hl.lineWidth : 2;

      ctx.save();
      ctx.beginPath();
      ctx.arc(x, py, radius, 0, Math.PI * 2);
      ctx.fillStyle = fill;
      ctx.fill();
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = stroke;
      ctx.stroke();
      ctx.restore();
    } catch (e) {
      // 無視
    }
  },
};

let registered = false;

// bpslogで使うChart.js要素/プラグインを一度だけregisterする。
export const registerBpsLogChartJs = () => {
  if (registered) return;
  registered = true;

  // react-chartjs-2 は内部で Chart.js を使うため、利用するスケールや要素を明示的に register する。
  ChartJS.register(
    Filler,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );

  ChartJS.register(crosshairPlugin);
  ChartJS.register(highlightPointPlugin);
  ChartJS.register(zoomPlugin);
};
